import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useChangeUsername = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post('/api/user/changeUsername', values)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { changeUsername: mutateAsync, isLoading };
};
